import OpenAPI from './OpenAPI';

export default OpenAPI;